import UsageMetrics from "./components/UsageMetrics/index";
import CommunityUsage from "./components/CommunityUsage";
import CipherActivity from "./components/CipherActivity";
import { VerificationMetrics } from "./components/VerificationMetrics/index";
import CipherAdoption from "./components/CipherAdoption/index";

export default function Dashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Dashboard</h1>

      <UsageMetrics />
      <CommunityUsage />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <CipherActivity />
        <VerificationMetrics />
        <CipherAdoption />
      </div>
    </div>
  );
}
